import { render, staticRenderFns } from "./news-letter.vue?vue&type=template&id=0b97c1ea&scoped=true"
import script from "./news-letter.vue?vue&type=script&lang=js"
export * from "./news-letter.vue?vue&type=script&lang=js"
import style0 from "./news-letter.vue?vue&type=style&index=0&id=0b97c1ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b97c1ea",
  null
  
)

export default component.exports